import ModalConfirmationSuppression from "./modal-confirmation-suppression";
import ModalConfirmationModification from "./modal-confirmation-modification";

require("../require");
require("./page.scss");

export const modalConfirmationSuppression = new ModalConfirmationSuppression();
export const modalConfirmationModification = new ModalConfirmationModification();
